/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErrorDto from '../model/ErrorDto';
import ErrorLogDto from '../model/ErrorLogDto';
import ErrorLogInputDto from '../model/ErrorLogInputDto';
import PaginatedErrorLogsDto from '../model/PaginatedErrorLogsDto';

/**
* ErrorLog service.
* @module api/ErrorLogApi
* @version v0
*/
export default class ErrorLogApi {

    /**
    * Constructs a new ErrorLogApi. 
    * @alias module:api/ErrorLogApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createErrorLog operation.
     * @callback module:api/ErrorLogApi~createErrorLogCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ErrorLogDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new error log entry
     * @param {module:model/ErrorLogInputDto} errorLogInputDto 
     * @param {module:api/ErrorLogApi~createErrorLogCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ErrorLogDto}
     */
    createErrorLog(errorLogInputDto, callback) {
      let postBody = errorLogInputDto;
      // verify the required parameter 'errorLogInputDto' is set
      if (errorLogInputDto === undefined || errorLogInputDto === null) {
        throw new Error("Missing the required parameter 'errorLogInputDto' when calling createErrorLog");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ErrorLogDto;
      return this.apiClient.callApi(
        '/api/private/error-log', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteErrorLogById operation.
     * @callback module:api/ErrorLogApi~deleteErrorLogByIdCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete an error log by ID
     * @param {Number} id ID of the error log to delete
     * @param {module:api/ErrorLogApi~deleteErrorLogByIdCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteErrorLogById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteErrorLogById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/error-log/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getErrorLogById operation.
     * @callback module:api/ErrorLogApi~getErrorLogByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ErrorLogDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get an error log by ID
     * @param {Number} id ID of the error log to retrieve
     * @param {module:api/ErrorLogApi~getErrorLogByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ErrorLogDto}
     */
    getErrorLogById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getErrorLogById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ErrorLogDto;
      return this.apiClient.callApi(
        '/api/private/error-log/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getErrorLogs operation.
     * @callback module:api/ErrorLogApi~getErrorLogsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedErrorLogsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all error logs (paginated)
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number
     * @param {Number} opts.limit Number of items per page
     * @param {Number} opts.userId Filter by user ID
     * @param {String} opts.errorType Filter by error type
     * @param {Date} opts.startDate Filter errors from this date (ISO 8601 format)
     * @param {Date} opts.endDate Filter errors until this date (ISO 8601 format)
     * @param {module:api/ErrorLogApi~getErrorLogsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedErrorLogsDto}
     */
    getErrorLogs(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'limit': opts['limit'],
        'userId': opts['userId'],
        'errorType': opts['errorType'],
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedErrorLogsDto;
      return this.apiClient.callApi(
        '/api/private/error-log', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecentErrorLogs operation.
     * @callback module:api/ErrorLogApi~getRecentErrorLogsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ErrorLogDto>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the 10 most recent error logs
     * @param {module:api/ErrorLogApi~getRecentErrorLogsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ErrorLogDto>}
     */
    getRecentErrorLogs(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ErrorLogDto];
      return this.apiClient.callApi(
        '/api/private/error-log/recent', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
